/**
 * Normalize a video URL into an embeddable iframe src.
 * Converts common YouTube share/watch/shorts links (which YouTube refuses to
 * embed in an <iframe>) into the proper /embed/{id} form. Vimeo watch links are
 * also handled. Unknown providers / already-embed URLs are returned unchanged.
 */
export function toEmbedUrl(url?: string | null): string {
  if (!url) return '';
  const u = url.trim();

  // Already an embed player URL
  if (/\/embed\//.test(u) || /player\.vimeo\.com/.test(u)) return u;

  // youtu.be/<id>
  let m = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;

  // youtube.com/watch?v=<id>
  m = u.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;

  // youtube.com/shorts/<id>  or  /live/<id>
  m = u.match(/youtube\.com\/(?:shorts|live)\/([A-Za-z0-9_-]{6,})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;

  // vimeo.com/<id>
  m = u.match(/vimeo\.com\/(\d+)/);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;

  return u;
}
